<template>
    <div v-on:click="celebrate()">
        <div class="flex flex-col items-center">
            <div class="flex items-center text-32 font-bold text-onyx">
                Great job<span v-if="firstName">, {{ firstName }}</span>!
            </div>
            <div class="mx-auto z-999999" ref="button"></div>
        </div>
    </div>
</template>

<script>
import { confetti } from 'dom-confetti';

export default {
    props: ['firstName'],
    data() {
        return {
            incrementing: 1,
            svgContainer: false,
        }
    },
    mounted() {
        this.$nextTick(()=> {
            this.celebrate();
            this.svgClickListener();
        });
    },
    methods: {
        celebrate() {},
        svgClickListener() {
            if (this.$refs.image) {
                this.$refs.image.addEventListener("load", () => {
                    let svgDoc = this.$refs.image.contentDocument;
                    let svgContainer = svgDoc.getElementById("e3xkx7li3v0f1");
                    if (svgContainer) {
                        svgContainer.addEventListener("mousedown", () =>{
                            this.celebrate();
                        }, false);
                    }
                });
            }
        }
    }
}


</script>